import { useGetTeam } from '@entities/myTeam/lib/hooks';

export const useEmployeesList = () => {
    const { data } = useGetTeam();
    const employees = data?.employees ?? [];

    return { employees };
};
